import { AutoRefundCheckData } from 'shared/api/avia/auto-refund'

interface AutoRefundPrice {
  price: number
  price_with_promo_code?: string
}

export interface AutoRefundAmounts {
  fee: number
  refund: number
  total: number
}

const DECIMAL_AMOUNT_PATTERN = /^\d+(?:\.\d+)?$/

const parseAmount = (value: number | string) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }

  const normalizedValue = value.trim()

  if (!DECIMAL_AMOUNT_PATTERN.test(normalizedValue)) return null

  const amount = Number(normalizedValue)

  return Number.isFinite(amount) ? amount : null
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const getAutoRefundAmounts = (
  ticket: AutoRefundPrice,
  refundFee: string,
): AutoRefundAmounts | null => {
  const totalValue = ticket.price_with_promo_code || ticket.price
  const total = parseAmount(totalValue)
  const fee = parseAmount(refundFee)

  if (total === null || fee === null) return null

  const refund = total - fee

  if (
    !Number.isFinite(total) ||
    !Number.isFinite(fee) ||
    total < 0 ||
    fee < 0 ||
    refund < 0
  ) {
    return null
  }

  return { fee, refund, total }
}

export const isAutoRefundConfirmationValid = (value: string) =>
  value.trim().toLocaleLowerCase('ru-RU') === 'согласен'

export const isAutoRefundCheckData = (
  value: unknown,
): value is AutoRefundCheckData => {
  if (!isRecord(value) || !isRecord(value.payment_fee)) return false

  return (
    typeof value.confirm_code === 'string' &&
    Boolean(value.confirm_code.trim()) &&
    typeof value.payment_fee.total === 'string' &&
    typeof value.payment_fee.currency === 'string' &&
    value.payment_fee.currency === 'KGS'
  )
}

export const isAutoRefundProcessSuccessful = (value: unknown) =>
  isRecord(value) && value.refund_success === true
